var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "pop-dialog pop-import",
      attrs: {
        title: "批量导入",
        visible: _vm.visibleDialog,
        width: "520px",
        top: "calc(50vh - 150px)",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleDialog = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "import-con" },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v("请使用导入模版数据，并上传Excel"),
          ]),
          _c(
            "el-upload",
            {
              ref: "tops",
              staticClass: "upload-con",
              attrs: {
                accept: ".doc,.docx,.xls,.xlsx,.csv",
                drag: "",
                action: "#",
                multiple: false,
                "http-request": _vm.orderImport,
                limit: 1,
              },
            },
            [
              _c("i", { staticClass: "el-icon-upload" }),
              _c("div", { staticClass: "el-upload__text" }, [
                _vm._v(" 将文件拖到此处，或"),
                _c("em", [_vm._v("点击上传")]),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "dialog-footer" }, [
        _c(
          "div",
          {
            on: {
              click: function ($event) {
                return _vm.downloadlink(_vm.link)
              },
            },
          },
          [
            _c(
              "el-button",
              {
                attrs: { type: "text", size: "mini", icon: "el-icon-download" },
              },
              [_vm._v("导入模板下载")]
            ),
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                attrs: { size: "mini" },
                on: {
                  click: function ($event) {
                    _vm.visibleDialog = false
                  },
                },
              },
              [_vm._v("取 消")]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "mini", loading: _vm.loading },
                on: { click: _vm.onConfirm },
              },
              [_vm._v("确 定")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }